import React, { Component } from 'react'
import './CorporateDeals.css'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { ProductFeature, doFeatureProductRes} from '../../action/FeatureProductAction';
import {ProductListing, doNewProductListingRes} from '../../action/NewProductListingAction';
import { menuCategory, doMenuCategoryRes } from '../../action/MenuCategoryAction';
import { formCorporateDeals , doCorporateDealsFormRes } from '../../action/CorporateDealsFormAction';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
// import Carousel from 'react-elastic-carousel'
import loaderImg from '../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';

import ReactGA from 'react-ga';
import CookieConsent from "react-cookie-consent";
import ReactPixel from 'react-facebook-pixel';

import successGif from '../../assets/images/success.gif';

// const breakPoints = [
//     { width: 1, itemsToShow: 1 },
//     { width: 550, itemsToShow: 2},
//     { width: 768, itemsToShow: 4 },
//     { width: 1200, itemsToShow: 4 }
// ];

var pattern = /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i;
var mobileNo_pattern = new RegExp(/^[0-9\b]+$/)
let formStatus = false;
class CorporateDeals extends Component {
    constructor(){
        formStatus = false
        super();
        this.state={
            categoryImageList: [],
            categoryImgUrl:[],
            featureProductSliderData: [],
            newProductListData: [],
            uiRender: false,
            featureSliderData:[],            
            MenuCategorydata: [],
            isLoader: false,
            bannerListFirst:'',
            bannerListSecond: '',
            bannerListThird: '',
            bannerListFourth: '',
            isSubmited: false,
            contactName: '',
            email: '',
            contact_number: '',
            description : '',
            isCorporateForm : true,
            isSuccessForm : false,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }
    
    componentDidMount(){
        const data = {}
        
        // this.props.category_list(data)
        const featureProductdata = {}
        const ProductListingdata ={}
        // const data = {}
        this.setState({
            isLoader: true
        })
        this.props.ProductFeature(featureProductdata)        
        this.props.ProductListing(ProductListingdata)
        this.props.menuCategory(data)
       

    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doFeatureProductRes && nextProps.doFeatureProductRes.user){
            if(nextProps.doFeatureProductRes.user && nextProps.doFeatureProductRes.user.FeatureProductRes){
                if(nextProps.doFeatureProductRes.user.FeatureProductRes && nextProps.doFeatureProductRes.user.FeatureProductRes.results === true){
                    this.setState({
                        featureProductSliderData : nextProps.doFeatureProductRes.user.FeatureProductRes.data,
                        isLoader: false
                    })
                } else{
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if(nextProps.doNewProductListingRes && nextProps.doNewProductListingRes.user){
            if(nextProps.doNewProductListingRes.user && nextProps.doNewProductListingRes.user.NewProductListingRes){
                if(nextProps.doNewProductListingRes.user.NewProductListingRes && nextProps.doNewProductListingRes.user.NewProductListingRes.results === true){
                    this.setState({
                        newProductListData : nextProps.doNewProductListingRes.user.NewProductListingRes.data,
                        isLoader: false
                    })
                } else{
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if(nextProps.doMenuCategoryRes && nextProps.doMenuCategoryRes.user){
            if(nextProps.doMenuCategoryRes.user && nextProps.doMenuCategoryRes.user.MenuCategoryRes){                
                if(nextProps.doMenuCategoryRes.user.MenuCategoryRes && nextProps.doMenuCategoryRes.user.MenuCategoryRes.result === true){
                    this.setState({
                        MenuCategorydata : nextProps.doMenuCategoryRes.user.MenuCategoryRes.category,
                        isLoader: false
                    })
                    
                } else{
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if(nextProps.doCorporateDealsFormRes && nextProps.doCorporateDealsFormRes.user){
            if(nextProps.doCorporateDealsFormRes.user && nextProps.doCorporateDealsFormRes.user.CorporateDealsFormRes){
                if(nextProps.doCorporateDealsFormRes.user.CorporateDealsFormRes && nextProps.doCorporateDealsFormRes.user.CorporateDealsFormRes.result === true && formStatus){
                    formStatus= false
                    this.setState({
                        isCorporateForm : false,
                        isSuccessForm : true
                    })
                }
            }
        }
    }


    productDetails=(item)=>{
        if(item.product_type === "customize"){
            if(item.cat_name === "KEY CHAIN"){
                this.props.history.push('/productkeycustomize/'+item.product_id+'/'+item.slug, {
                        product_type: item.product_type,
                        product_id:item.product_id,
                        is_varient: item.is_varient
                    })
            }
            if(item.cat_name === "MUG"){
                this.props.history.push('/productcupcustomize/'+item.product_id+'/'+item.slug, {
                    product_type: item.product_type,
                    product_id:item.product_id,
                    is_varient: item.is_varient
                })
            } 
            if(item.sub_cat_id === "10"){
                window.location.href = '/productcustomize/1/'+item.sub_cat_id+'/'+item.slug
            } 
            if(item.sub_cat_id === "14"){
                window.location.href = '/productmobilecustomize/3/'+item.sub_cat_id+'/'+item.slug
            }
            if(item.sub_cat_id === '11'){
                window.location.href = '/productwomencustomize/17/'+item.sub_cat_id+'/'+item.slug
            }
            if(item.sub_cat_id === '17'){
                window.location.href = '/productkidscustomize/20/'+item.sub_cat_id+'/'+item.slug
            }
            if(item.cat_name === "COMBOS"){
                window.location.href = '/product/21/'+item.sub_cat_id+'/'+item.slug
                this.props.history.push('/product/21/'+item.sub_cat_id+'/'+item.slug ,{
                    sub_id: item.sub_cat_id,
                    cat_id: "21"
                })
            }
            

        } else if (item.product_type === "simple" || item.product_type === "Simple"){
            if(item.sub_cat_id === '345'){
                window.location.href = '/productcouplecombo/'+item.product_id+'/'+item.slug
                this.props.history.push('/productcouplecombo/'+item.product_id+'/'+item.slug, {
                    product_type: item.product_type,
                    product_id:item.product_id,
                    is_varient: item.is_varient,
                    slug: item.slug
                })
            }else if(item.cat_name === "MUG" && item.is_varient==="0"){
                window.location.href = '/product-mug-view/'+item.product_id+'/'+item.slug
                this.props.history.push({
                    pathname: `/product-mug-view/${item.product_id}/${item.slug}`,
                    state: item
                });
            } else{
                
                window.location.href = '/productview/'+item.product_id+'/'+item.slug+'?size='+item.size+'&color='+item.color.replace(" ", "+")+'&sleves='+item.sleeve.replace(" ", "+")
                this.props.history.push('/productview/'+item.product_id+'/'+item.slug+'?size='+item.size+'&color='+item.color.replace(" ", "+")+'&sleves='+item.sleeve.replace(" ", "+"), {
                    product_type: item.product_type,
                    product_id:item.product_id,
                    is_varient: item.is_varient,
                    sub_cat_id: item.sub_cat_id
                })
            }
            
        } 
        
    }

    productCategory=(item)=>{
        this.props.history.push('/menu-subcatrgory/'+item.id+'/'+item.slug,{
            productCategoryData : item
        })
    }

    productMobileDetails=()=>{

        for(let menuItem of this.state.MenuCategorydata){
            for(let imageItem of menuItem.sub_cat){
                if(imageItem.sub_id === "14"){
                    window.location.href = '/productmobilecustomize/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug
                }                
            }
        }
        
    }

    productBannerDetails=(url)=>{
        window.location.href = url
        // for(let menuItem of this.state.MenuCategorydata){
        //     for(let imageItem of menuItem.sub_cat){
        //         if(imageItem.sub_id === "343"){
        //             window.location.href = '/product/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug
        //         }
        //     }
        // } 
    }

    productTshirtDetails=()=>{
        for(let menuItem of this.state.MenuCategorydata){
            for(let imageItem of menuItem.sub_cat){
                if(imageItem.sub_id === "10"){
                    window.location.href = '/productcustomize/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug
                }
            }
        } 
    }

    productGraduationDetails=()=>{
        for(let menuItem of this.state.MenuCategorydata){
            for(let imageItem of menuItem.sub_cat){
                // if(imageItem.sub_id === "10"){
                //     window.location.href = '/productcustomize/'+imageItem.slug
                // }
                if(imageItem.sub_id === "2"){
                    window.location.href = '/product/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug
                    this.props.history.push('/product/'+imageItem.cat_id+'/'+imageItem.sub_id+'/'+imageItem.slug ,{
                        sub_id: imageItem.sub_id,
                        cat_id: imageItem.cat_id
                    })
                }
                
            }
        } 
    }

    


    validate(values) {
        const errors = {};  
        if(values.contactName && values.contactName.trim() === ''){
            errors.contactName = '*Please enter company name';
        }else if(values.contactName === null){
        errors.contactName = '*Please enter company name';
        }else if(values.contactName === undefined){
        errors.contactName = '*Please enter company name';
        }else if(values.contactName === ''){
        errors.contactName = '*Please enter company name';
        }      
        
        if (values.email && values.email === '') {
            errors.email = '*Please enter emailid';
        }else if (values.email && values.email.trim() === '') {
          errors.email = '*Please enter emailid';
        }else if(values.email === undefined){
            errors.email = '*Please enter emailid';
        }else if (!pattern.test(values.email)) {
            errors.email = "*Please enter valid email address.";
        }
    
        if(values.contact_number && values.contact_number.trim() === ''){
          errors.contact_number = '*Please enter contact number';
        }else if(values.contact_number === null){
          errors.contact_number = '*Please enter contact number';
        }else if(values.contact_number === undefined){
          errors.contact_number = '*Please enter contact number';
        }else if(values.contact_number === ''){
          errors.contact_number = '*Please enter contact number';
        } else if(!mobileNo_pattern.test(values.contact_number)){
            errors.contact_number = '*Please enter only number';
        }else if(values.contact_number.length !== 10){
            errors.contact_number = '*Please enter valid phone number.';
        }
        
        if(values.description && values.description.trim() === ''){
            errors.description = '*Please enter description';
          }else if(values.description === null){
            errors.description = '*Please enter description';
          }else if(values.description === undefined){
            errors.description = '*Please enter description';
          }else if(values.description === ''){
            errors.description = '*Please enter description';
          } 
        return errors;      
    }

    contactSubmit = e =>{
        e.preventDefault();
        this.setState({
            isSubmited: true,        
        }, () => { });
        this.validate(this.state);
        const errors = this.validate(this.state);
        if (Object.keys(errors).length === 0) { 
            let requestData = {
                contactName : this.state.contactName,
                email : this.state.email,
                contact_number: this.state.contact_number,
                description: this.state.description
            }
            this.setState({
                // isLoader: true
            })
            formStatus = true
            this.props.formCorporateDeals(requestData)
        }

    }

    returnCorporateForm =()=>{
        this.setState({
            contactName: '',
            email: '',
            contact_number: '',
            description : '',
            isCorporateForm : true,
            isSuccessForm : false,
        })
    }

    render() {                
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        const errors = this.validate(this.state);
        const {isSubmited, isSuccessForm, isCorporateForm} = this.state;           
        return (
            <React.Fragment>
                
                <div className="page-wrapper">
                            
                    <CookieConsent
                        location="bottom"
                        buttonText="ALLOW COOKIES"
                        cookieName="myAwesomeCookieName2"
                        style={{ background: "#fff" }}
                        buttonStyle={{ color: "#fff", fontSize: "13px", padding: "15px", margin:"20px",     marginRight: '250px', background: '#1b75bc' }}
                        expires={150}
                        >
                        <div className="cookie-disply-margin">
                        <p className="cookie-p dis-cookie-flex">We use cookies to collect and analyse information on site performance and usage, to provide social media features and to enhance and customise content and advertisements. </p>
                        <span className="cookie-learn"><a href="https://www.cookiehub.com/about-cookies?en" rel="noopener" target="_self" className="cookie-learn">Learn more</a></span>
                        </div>
                    </CookieConsent>
                    <LayoutWrapper />
                    
                    <Loader show={this.state.isLoader} message={spinner}> 
                    
                        <main className="main main-container">
                            <div className="home-top-container">
                                <div className="page-header-corp">
                                    <div className="container">
                                        <h2 className="title_corporate text-center">For Corporate Deals Contact Us</h2>
                                    </div>
                                    {/* End .container */}
                                </div>
                                <div className="container">
                                    <div className="form-continer">
                                        <div className="row justify-content-center">
                                            {
                                                isCorporateForm &&
                                                <div className="col-md-6">
                                                    <form onSubmit = {this.contactSubmit}>
                                                        <div className="form-group required-field">
                                                            <label htmlFor="contact-name">Company Name</label>
                                                            <input type="text" className="form-control form-max-width" id="contact-name" name="contactName" autoComplete="off" onChange = {(e) => this.setState({contactName: e.target.value})} value = {this.state.contactName} />
                                                            {errors && isSubmited && <span className="error-message msg">{errors.contactName}</span>}
                                                        </div>
                                                        {/* End .form-group */}
                                                        <div className="form-group required-field">
                                                            <label htmlFor="contact-email">Email</label>
                                                            <input type="email" autoComplete="off" className="form-control form-max-width" id="contact-email" name="email" onChange = {(e) => this.setState({email: e.target.value})} value = {this.state.email} />
                                                            {errors && isSubmited && <span className="error-message msg">{errors.email}</span>}
                                                        </div>
                                                        {/* End .form-group */}
                                                        <div className="form-group required-field">
                                                            <label htmlFor="contact-subject">Contact No</label>
                                                            <input type="text" autoComplete="off" className="form-control form-max-width" id="contact-subject" name="contact_number" onChange = {(e) => this.setState({contact_number: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')})} value = {this.state.contact_number} />
                                                            {errors && isSubmited && <span className="error-message msg">{errors.contact_number}</span>}
                                                        </div>
                                                        {/* End .form-group */}
                                                        <div className="form-group required-field">
                                                            <label htmlFor="contact-message">Description</label>
                                                            <textarea cols="30" rows="1" id="contact-message" className="form-control textAreaSize form-max-width" name="description" autoComplete="off" onChange = {(e) => this.setState({description: e.target.value})} value = {this.state.description} ></textarea>
                                                            {errors && isSubmited && <span className="error-message msg">{errors.description }</span>}
                                                        </div>
                                                        {/* End .form-group */}
                                                        <div className="form-footer">
                                                            <button type="submit" className="btn btn-primary show-color" >Submit</button>
                                                        </div>
                                                        {/* End .form-footer */}
                                                    </form>
                                                </div> 
                                            }
                                            {
                                                isSuccessForm &&
                                                <div className="col-md-5">
                                                    <div className="center-img"><img src={successGif} width="100" height="100" alt="success"/></div>
                                                    <div className="center-img"><h4>Thank you for your interest in corporate deal</h4></div>
                                                    <div className="center-img">
                                                        <button type="submit" className="btn btn-primary show-color"  onClick={this.returnCorporateForm}>Ok</button>
                                                    </div>
                                                </div>
                                            }
                                                                                
                                        </div>
                                    </div>
                                    {/* End .row  */}
                                </div>
                                {/* End .container */}
                            </div>
                            {/* End .home-top-container  */}

                            {/*Just */}

                            {/* <div className="container arrived-products">
                                <h2 className="subtitle">
                                    <span>Just Arrived</span>
                                </h2>

                                <div className="row row-sm">
                                    

                                    <Carousel itemPadding={[10, 10]} itemsToShow={5} breakPoints={breakPoints}>
                                    {this.state.newProductListData && this.state.newProductListData.map((item, i) =>(
                                        <div key={i}>
                                            <div className="product-default inner-quickview inner-icon inner-icon-inline inner-btn">
                                                
                                                <div className="img-child">
                                                    <figure>
                                                        <div className="pointer img-wdth img-height img-just"  onClick={()=>this.productDetails(item)} style={{"backgroundImage": 'url('+item.photo+')'}}/>
                                                    </figure>
                                                </div>
                                                
                                                <div className="product-details text-center">
                                                    <h2 className="product-title">
                                                        <span className="product-name pointer " onClick={()=>this.productDetails(item)}>{item.name}</span>
                                                    </h2>
                                                    <div className="price-box">
                                                        <span className="old-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.price}.00</span>

                                                        <span className="product-price"><i className="fa fa-rupee-sign" aria-hidden="true"></i>{item.sale_price}.00</span>
                                                    </div>
                                                    <button className="btn btn-primary text-white show-color" data-toggle="modal" data-target="#addCartModal" onClick={()=>this.productDetails(item)}>Show Details</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}                                    
                                    </Carousel>      
                                </div>
                            </div> */}
                            <div className="mb-5"></div>                     
                        </main>
                        {/* End .main */}
                    </Loader>
            
                
                </div>
                <Footer />
            </React.Fragment>
        )
    }
}

CorporateDeals.propTypes = {
    doFeatureProductRes: PropTypes.any,
    doNewProductListingRes: PropTypes.any,
    doMenuCategoryRes: PropTypes.any,
    doCorporateDealsFormRes: PropTypes.any,

};

const mapStateToProps = createStructuredSelector({
    doFeatureProductRes: doFeatureProductRes,
    doNewProductListingRes: doNewProductListingRes,
    doMenuCategoryRes: doMenuCategoryRes,
    doCorporateDealsFormRes : doCorporateDealsFormRes,
});

function mapDispatchToProps(dispatch) {
    return {
        ProductFeature: (data) => dispatch(ProductFeature(data)),
        ProductListing: (data) => dispatch(ProductListing(data)),
        menuCategory: (data) => dispatch(menuCategory(data)),
        formCorporateDeals: (data) => dispatch(formCorporateDeals(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default  compose(withConnect)(CorporateDeals) 
